"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IsochroneService = void 0;
var _models = require("../models");
var _cyclingProfile = require("./cycling-profile");
var _http = require("./http");
class IsochroneService {
  static async computeIsochrones({
    durations,
    locations,
    profile,
    eBikeEnabled,
    partner
  }) {
    try {
      const data = await _http.HttpService.post('v2', '/isochrones', [{
        key: 'profile',
        value: _cyclingProfile.cyclingProfilesMap[profile || 'direct']
      }, {
        key: 'ebike',
        value: Boolean(eBikeEnabled)
      }], [], JSON.stringify({
        durations,
        locations
      }), {
        partner: partner?.code
      });
      const isochrones = [];
      durations.forEach(duration => {
        isochrones.push(new _models.Isochrone(duration, {
          type: 'Polygon',
          coordinates: data.filter(({
            duration: _duration
          }) => _duration === duration).reduce((res, {
            geometry: {
              coordinates
            }
          }) => {
            res.push(coordinates);
            return res;
          }, [])
        }));
      });
      return isochrones;
    } catch (err) {
      console.error('[IsochroneService][computeIsochrones]', err);
      throw new Error('isochrones computing failed');
    }
  }
  static async computeGraphHopperIsochrones({
    center,
    profile,
    duration,
    buckets
  }) {
    try {
      const queryParams = [{
        key: 'point',
        value: center.coordinates.slice().reverse().join(',')
      }, {
        key: 'profile',
        value: profile === 'safe' ? 'bicycle_safe' : 'bicycle_direct'
      }, {
        key: 'time_limit',
        value: duration
      }, {
        key: 'buckets',
        value: buckets
      }];
      const {
        polygons
      } = await _http.HttpService.get('v1', '/graphhopper/isochrone', queryParams);
      return polygons.map(({
        geometry: {
          coordinates
        },
        properties: {
          bucket
        }
      }) => new _models.Isochrone(duration / (buckets - bucket), {
        type: 'Polygon',
        coordinates
      }));
    } catch (err) {
      console.error('[IsochroneService][computeGraphHopperIsochrones]', err);
      throw new Error('isochrones computing failed');
    }
  }
  static async getIsochronesFile({
    durations,
    locations,
    profile,
    eBikeEnabled
  }) {
    try {
      const data = await _http.HttpService.post('v2', '/isochrone', [{
        key: 'content-type',
        value: 'shapefile'
      }, {
        key: 'profile',
        value: _cyclingProfile.cyclingProfilesMap[profile || 'direct']
      }, {
        key: 'ebike',
        value: Boolean(eBikeEnabled)
      }], [], JSON.stringify({
        durations,
        locations
      }), {
        responseType: 'blob'
      });
      return data;
    } catch (err) {
      console.error('[IsochroneService][downloadIsochrones]', err);
      throw err;
    }
  }
}
exports.IsochroneService = IsochroneService;